import { render, staticRenderFns } from "./softDown.vue?vue&type=template&id=fac294ee&scoped=true"
import script from "./softDown.vue?vue&type=script&lang=js"
export * from "./softDown.vue?vue&type=script&lang=js"
import style0 from "./softDown.vue?vue&type=style&index=0&id=fac294ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac294ee",
  null
  
)

export default component.exports